<div class="policy-modal">
    @if (mode === 'first-time') {
        <p class="policy-modal__description">
            {{ 'legal.acceptance.firstTimeDescription' | translate }}
        </p>
    } @else {
        <p class="policy-modal__description">
            {{ 'legal.acceptance.updateDescription' | translate }}
        </p>
    }

    <div class="policy-modal__content">
        @if (loading) {
            <div class="policy-modal__loading">
                <p-progressSpinner strokeWidth="4"></p-progressSpinner>
            </div>
        } @else if (policy) {
            <div [innerHTML]="policy.content"></div>
        } @else {
            <p>{{ 'legal.acceptance.loadError' | translate }}</p>
        }
    </div>

    <div class="policy-modal__actions">
        <p-button
                [label]="'legal.acceptance.logout' | translate"
                severity="secondary"
                [text]="true"
                (onClick)="logout()"
                [disabled]="accepting">
        </p-button>
        <p-button
                [label]="'legal.acceptance.accept' | translate"
                severity="success"
                (onClick)="accept()"
                [disabled]="loading || !policy || accepting"
                [loading]="accepting">
        </p-button>
    </div>
</div>
